module.exports = __webpack_public_path__ + "files/4ff9d2f033693b9cc7a2b865b726d89b.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Lora-regular.woff
// module id = 771
// module chunks = 60